import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { persistStore } from 'reduxjs-toolkit-persist';
// import storage from 'reduxjs-toolkit-persist/lib/storage'; // defaults to localStorage for web
import reducers from './reducer/reducer';

/*

COMMENTED OUT AS WE DO NOT WANT TO STORE THE STATE DUE TO THE SENSITIVE NATURE OF THE DATA

const persistConfig = {
    key: 'root',
    storage,
};
const persistedReducer = persistCombineReducers(persistConfig, reducers);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false,
    }),
});
*/

export const store = configureStore({
    reducer: reducers,
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
ReturnType,
RootState,
unknown,
Action<string>
>;
